import AxiosInstance from '../../../http-config';
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey';
import { getAppConfigurationValue, getUserName } from '../../../../redux/helpers';

export const apiRunPriceEngine = async (priceID: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia);

  // return await AxiosInstance.post(`${apiSuffixUrl}/engine/price/${priceID}`).then(response => {
  // return response.data;
  // });

  AxiosInstance.post(`${apiSuffixUrl}/engine/price/${priceID}`);
  return new Promise((resolve, reject) => {
    resolve({ success: true });
  });
};

export const apiPriceEngine = async (priceID: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia);

  AxiosInstance.post(`${apiSuffixUrl}/engine/prices/${priceID}`, '',
    {
      headers: {
        //"x-asr-connection-request-id": connectionId,
        "x-asr-user-request-id": getUserName()
      }
    });

  return new Promise((resolve, reject) => {
    resolve({ success: true });
  });
};
